export default "__VITE_ASSET__hNjehhSA__"